/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Nav_DownloadInputs */

const en_fc_nav_download = /** @type {(inputs: Fc_Nav_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {Fc_Nav_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_nav_download = /** @type {((inputs?: Fc_Nav_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Nav_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_nav_download(inputs)
});
export { fc_nav_download as "fc.nav.download" }